import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";
import {
  CreateRequestData,
  CreateMyRequestData,
  RequestFilters,
} from "../interfaces/requests.interface";

class RequestsService {
  private static instance: RequestsService;

  static getInstance(): RequestsService {
    if (!RequestsService.instance) {
      RequestsService.instance = new RequestsService();
    }
    return RequestsService.instance;
  }

  // Create new request (public/create flow)
  createRequest = (data: CreateRequestData) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<any>("/requests", data);
    });
  };

  // Get requests with filters (supports userId for "my requests")
  getRequests = (params?: RequestFilters) => {
    return requestWithErrorHandling(async () => {
      const queryParams = new URLSearchParams();
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined) {
            queryParams.append(key, value.toString());
          }
        });
      }
      return await apiService.get<any>(`/requests?${queryParams.toString()}`);
    });
  };

  // Create request from My Requests form (productName, origin, price range, etc.)
  createMyRequest = (data: CreateMyRequestData) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<any>("/requests", data);
    });
  };

  // Update request status (PUT /requests/:id)
  updateRequestStatus = (requestId: string, status: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.put<any>(`/requests/${requestId}`, { status });
    });
  };

  // Delete request
  deleteRequest = (requestId: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.delete<any>(`/requests/${requestId}`);
    });
  };

  // Get image upload URL
  getImageUploadUrl = (params: { fileName: string; fileType: string }) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<any>("/requests/images/upload-url", params);
    });
  };
}

export const requestsService = RequestsService.getInstance();
